import LoginService from '../../data/LoginService';

const recoverPassword = (email: string) => LoginService.recoverPassword(email);

export default recoverPassword;
